<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm khu vực</div>
      <div v-else>Chỉnh sửa khu vực</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm khu vực'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã khu vực*</label>
            <div class="p-col-8">
              <!-- <InputMask mask="***" v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã khu vực(3 ký tự)" /> -->
              <InputText @keydown.space.prevent v-model="code" id="code" type="text" class="p-col-width" placeholder="Nhập mã khu vực"/>
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Quận/ Huyện quản lý</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedDistrict" :options="this.listDistrict" 
              optionLabel="name" placeholder="Chọn các Quận/Huyện quản lý" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['district']"
                class="p-invalid"
              >{{validationErrors['district']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <!-- Thêm xã phường xã phường mà không có quận huyện -->
            <label class="p-col-4 txt-left">Xã/ Phường quản lý</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedWard" :options="this.listWard" 
              optionLabel="name" placeholder="Chọn các Xã/Phường quản lý" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['ward']"
                class="p-invalid"
              >{{validationErrors['ward']}}</small>
            </div>

          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      address: '',
      code: '',
      listDistrict: [],
      selectedDistrict: [],
      listWard: [],
      selectedWard: [],
      listArea: []
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.area_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------', this.selectedDistrict)
      this.validationErrors = {};
      var has_error = false
      // if (this.selectedDistrict.length == 0) {
      //   this.validationErrors['district'] = 'Vui lòng chọn quận/huyện quản lý';
      //   has_error = true
      // }
      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã khu vực';
        has_error = true
      } else if(this.code.length < 2){
        this.validationErrors['code'] = 'Vui lòng nhập mã khu vực(2 ký tự trở lên)';
        has_error = true
      }else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            area(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.area[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã khu vực bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: Int) {
            area(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.area[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã khu vực bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_area = {}
        data_area['code'] = this.code
        data_area['address'] = this.address

        var data_item= []
        if(this.selectedDistrict.length > 0){
        for (let i = 0; i < this.selectedDistrict.length; i++) {
          const item = this.selectedDistrict[i]
          var data_item_item= {}
          data_item_item['district_id'] = item.id
          data_item.push(data_item_item)
        }
        }
        if(this.selectedWard.length > 0){
        for (let i = 0; i < this.selectedWard.length; i++) {
          const item = this.selectedWard[i]
          var data_item_item_ward= {}
          data_item_item_ward['ward_id'] = item.id
          data_item.push(data_item_item_ward)
        }
        }
        var data_area_item = {}
        data_area_item['data'] = data_item
        data_area['area_districts'] = data_area_item

      return data_area
    },
    async analyzeDataEdit() {
      var data_area = {}
        data_area['code'] = this.code
        data_area['address'] = this.address
      return data_area
    },
    async analyzeDataEditItem() {
      var data_item= []
      if(this.selectedDistrict.length > 0){
      for (let i = 0; i < this.selectedDistrict.length; i++) {
          const item = this.selectedDistrict[i]
          var data_item_item= {}
          data_item_item['area_id'] = this.area_id
          data_item_item['district_id'] = item.id
          data_item.push(data_item_item)
        }
      }
      if(this.selectedWard.length > 0){
        for (let i = 0; i < this.selectedWard.length; i++) {
          const item = this.selectedWard[i]
          var data_item_item_ward= {}
          data_item_item_ward['area_id'] = this.area_id
          data_item_item_ward['ward_id'] = item.id
          data_item.push(data_item_item_ward)
        }
      }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if(this.selectedDistrict.length == 0 && this.selectedWard.length == 0){
        this.$toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Vui lòng chọn quận/huyện hoặc xã/ phường quản lý",
          life: 3000
        });
        return;
      }
      if(this.selectedDistrict.length > 0 && this.selectedWard.length > 0){
        this.$toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Vui lòng chỉ chọn một trong hai: quận/huyện hoặc xã/phường để quản lý. Không được chọn cả hai.",
          life: 3000
        });
        return;
      }
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_area = await this.analyzeData()

        var query = `mutation MyMutation($objects: [area_insert_input!]!) {
            insert_area(objects: $objects) {
              affected_rows
              returning {
                id
                code
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_area]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-area'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_area_update = await this.analyzeDataEdit()
        let data_area_item = await this.analyzeDataEditItem()
        let query = `mutation MyMutation($area_id: Int!, $area_update: area_set_input, $objects: [area_district_insert_input!]!) {
          update_area(where: {id: {_eq: $area_id}}, _set: $area_update) {
            affected_rows
            returning {
              id
              code
            }
          }
          delete_area_district(where: {area_id: {_eq: $area_id}}) {
            affected_rows
          }
          insert_area_district(objects: $objects) {
            affected_rows
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              area_id: this.area_id,
              area_update: data_area_update,
              objects: data_area_item
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-area'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    ward_list_query:{
      query() {
        let query = `
          query MyQuery{
            ward(where: {state_id_merger: {_eq: 9},deleted: {_eq: false}}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.ward){
          this.listWard = data.ward
        }
      },
      fetchPolicy: "network-only",
    },
    district: {
      query() {
        let query = `
          query MyQuery{
            district(where: {state_id: {_eq: 9},deleted: {_eq: false}}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.district){
          this.listDistrict = data.district
        }
      },
      fetchPolicy: "network-only",
    },
    area: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            area(where: {id: {_eq: $id}}) {
              id
              code
              address
              area_districts {
                district {
                  id
                  name
                }   
                ward {
                  id
                  name
                }
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.area){
          this.listArea = data.area
          this.code = this.listArea[0].code
          this.address = this.listArea[0].address
          if (this.listArea[0].area_districts.length >0) {
            for (let i = 0; i < this.listArea[0].area_districts.length; i++) {
              const e = this.listArea[0].area_districts[i];
              if(e.district){
                this.selectedDistrict.push({id: e.district.id, name: e.district.name, __typename: "district"})
              }
              if(e.ward){
                this.selectedWard.push({id: e.ward.id, name: e.ward.name, __typename: "ward"})
              }
            }
          }
          console.log('ddddddddd', this.selectedDistrict)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
